import { Box, Button, Chip } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";

const InputUploadFile = (props) => {
  return (
    <Box style={{ height: "90px", marginTop: "10px", textAlign: "left" }}>
      {!props.filename && (
        <Button
          variant="outlined"
          component="label"
          color="primary"
          disabled={!props.deletable}
          sx={{
            height: "50px",
            color: "#091B3D",
            fontSize: "12px",
            backgroundColor: "#f5f8fc",
            width: "170px",
          }}
        >
          Ngarko dok
          <input
            onChange={props.onchangefile}
            value={props.filevalue}
            type="file"
            hidden
          />
        </Button>
      )}
      {props.filename && (
        <Chip
          icon={<GetAppIcon />}
          sx={{
            height: "30px",
            color: "#000",
            fontSize: "12px",
            background: "#f6f8fc",
            borderRadius: "8px",
          }}
          onClick={props.onClick}
          label={"Dokument_" + props.filename}
          variant="outlined"
          onDelete={props.deletable && props.onDelete}
        ></Chip>
      )}
    </Box>
  );
};

export default InputUploadFile;
